import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MarkdownComponents from "../../utils/MarkdownComponents";

const markdown = `
# Ticket Details

To view ticket details, navigate to the ticket ID or search for the ticket.

## Ticket Information

\`\`\`
+-------------------------------------------+
|              Ticket #4394                 |
+-------------------------------------------+
| Status:       In Progress                 |
| Priority:     P1                          |
| Type:         Service Request             |
| Created:      2025-07-07 06:17:40         |
| Due:          2025-07-07 09:30:00         |
| Category:     Collaboration               |
| Group:        1st Line                    |
| Agent:        Amith Malipatil             |
| Contact:      Ashwini (VIP)               |
| Source:       SSP                         |
| Active:       Yes                         |
+-------------------------------------------+
\`\`\`

## Ticket Log Details

\`\`\`
+-------------------------------------------+
|               Latest Update               |
+-------------------------------------------+
| Title:       sss                          |
| Note:        mmm                          |
| Description: sss                          |
| Private:     Yes                          |
| Updated:     2025-07-07 09:47:04          |
| Created By:  Amith Malipatil (Agent)      |
| Circulation: ashwini.thm@vizionsys.com    |
+-------------------------------------------+
\`\`\`

---

## How To Access This Data?

1. The frontend sends a GET request to the backend:

    \`\`\`http
    GET https://simplisysapi.vizionsys.com/gateway/Ticket/{ticketId}
    Authorization: Bearer <token>
    ... (see headers in UI)
    \`\`\`

2. The backend responds with the complete ticket data.

---

## Security Note

- Ticket data should only be accessible to authorized users
- Contact information (especially VIP contacts) requires additional protection
- Always use HTTPS for all requests
`;

export default function TicketDetail() {
 


  return (
    <>
      <MarkdownComponents markdown={markdown.replace('{ticketId}', '1212')} />

    </>
  );
}